import { t } from '@lingui/core/macro'
import { api } from 'api'
import { showSnackbar } from 'functions'

export function getFolders() {
  return dispatch => {
    api
      .get('/api/v1/account/folder')
      .then(res => {
        dispatch({ type: 'folders/all', payload: res.data })
      })
      .catch(() => {
        dispatch({ type: 'FAILED_TO_GET_FOLDERS', payload: false })
      })
  }
}

export function addFolder(folder) {
  return dispatch => {
    return api
      .put('/api/v1/account/folder', folder)
      .then(({ data }) => {
        dispatch({ type: 'folders/added', payload: data.folder })
        dispatch(
          showSnackbar({
            message: t`Folder was added successfully`,
            type: 'SUCCESS',
          }),
        )
      })
      .catch(() => {
        dispatch(
          showSnackbar({
            message: t`Folder failed to add. Please try again`,
            type: 'ERROR',
          }),
        )
      })
  }
}

export function updateFolder(folder) {
  return dispatch => {
    return api
      .put('/api/v1/account/folder', folder)
      .then(() => {
        dispatch({ type: 'folders/updateFolder', payload: folder })
        dispatch(
          showSnackbar({
            message: t`Folder was updated successfully`,
            type: 'SUCCESS',
          }),
        )
      })
      .catch(() => {
        dispatch(
          showSnackbar({
            message: t`Folder failed to update. Please try again`,
            type: 'ERROR',
          }),
        )
      })
  }
}

export function updateFolders(folders) {
  return dispatch => {
    dispatch({ type: 'folders/updated', payload: folders })
  }
}
